"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.useKnockRequest = useKnockRequest;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _reactRedux = require("react-redux");
var _utils = require("../../utils");
var _resources = require("../../resources");
var _KnockRequest = require("../../constants/KnockRequest");
var _reactRouterDom = require("react-router-dom");
var _metrics = require("@studio/metrics");
var _logger = require("@studio/logger");
function getKnockAction(knock, updateRequestAction, updateKnock) {
  return (0, _utils.isDirectorRequest)(knock.type) ? updateRequestAction : updateKnock;
}

/**
 * Checks if the notification message includes 'failed to join' or 'Source creation failed and returns message'
 *
 * @param {*} notification - The notification object that may contain an error message
 * @returns {String} - Returns message if the notification message includes 'failed to join' or 'Source creation failed', otherwise false
 */
function getKnockApprovalFailureMessage(notification) {
  var _notification$message, _notification$message2;
  if (notification !== null && notification !== void 0 && notification.show && ((_notification$message = notification.message) !== null && _notification$message !== void 0 && _notification$message.includes('failed to join') || (_notification$message2 = notification.message) !== null && _notification$message2 !== void 0 && _notification$message2.includes('Source creation failed'))) {
    return notification.message;
  }
}
function useKnockRequest(_ref) {
  var isToggled = _ref.isToggled,
    pendingKnocks = _ref.pendingKnocks,
    getPendingKnocksAction = _ref.getPendingKnocksAction,
    toggleNotificationListAction = _ref.toggleNotificationListAction,
    updateKnock = _ref.updateKnock,
    updateRequestAction = _ref.updateRequestAction,
    approveAllKnocksAction = _ref.approveAllKnocksAction;
  var _usePresenterAddedToC = (0, _metrics.usePresenterAddedToChimeSLI)(),
    startPresenterAddedToChimeSLI = _usePresenterAddedToC.startPresenterAddedToChimeSLI,
    endPresenterAddedToChimeSLI = _usePresenterAddedToC.endPresenterAddedToChimeSLI;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    start = _useState2[0],
    setStart = _useState2[1];
  var _useState3 = (0, _react.useState)(5000),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    timeRemaining = _useState4[0],
    setTimeRemaining = _useState4[1];
  var sources = (0, _reactRedux.useSelector)(function (state) {
    return state.broadcastSources.sources;
  });
  var notification = (0, _reactRedux.useSelector)(function (state) {
    return state.notification;
  }, _reactRedux.shallowEqual);
  var prevPendingRequest = (0, _react.useRef)(0);
  var notificationTimer = (0, _react.useRef)();
  var currentApproveActionRef = (0, _react.useRef)(_KnockRequest.BROADCAST_UPDATE_REQUEST);
  var dispatch = (0, _reactRedux.useDispatch)();
  var match = (0, _reactRouterDom.useRouteMatch)();
  var knockSound = _resources.resources.knockSound;

  // Get pending knocks when app loads
  (0, _react.useEffect)(function () {
    dispatch(getPendingKnocksAction());
  }, [dispatch]);

  // Toggle off the notification list after 5 seconds
  (0, _react.useEffect)(function () {
    if (isToggled) {
      notificationTimer.current = setTimeout(function () {
        dispatch(toggleNotificationListAction(false));
      }, 5000);
      setStart(Date.now());
      return function () {
        return clearTimeout(notificationTimer.current);
      };
    }
  }, [dispatch, isToggled]);
  var audioRef = (0, _react.useRef)(null);

  /**
   * We want to ring the notification bell only if a new request comes in
   */
  (0, _react.useEffect)(function () {
    if (!audioRef.current) {
      audioRef.current = new Audio(knockSound);
    }
    if (!!pendingKnocks.length && pendingKnocks.length >= prevPendingRequest.current) {
      var playPromise = audioRef.current.play();
      if (playPromise !== undefined) {
        playPromise["catch"](function (error) {
          (0, _utils.sendToDatadog)('Knocks', error, 'Unable to play knock request notification', true);
        });
      }
    }
    prevPendingRequest.current = pendingKnocks.length;
    return function () {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [pendingKnocks.length, knockSound]);
  var onApproveAll = (0, _react.useCallback)(function () {
    dispatch(approveAllKnocksAction());
    currentApproveActionRef.current = _KnockRequest.BROADCAST_APPROVE_ALL_KNOCKS;
  }, [dispatch]);
  var updateKnockRequest = (0, _react.useCallback)(function (knock, changes) {
    var updateKnockAction = getKnockAction(knock, updateRequestAction, updateKnock);
    dispatch(updateKnockAction(knock, changes));
    if (knock.type === 'presenter' && changes.status === 'accepted') {
      startPresenterAddedToChimeSLI(knock.presenterId, (0, _logger.getNameInitials)(knock.name), knock.sessionId, match.path, match.url);
      currentApproveActionRef.current = _KnockRequest.BROADCAST_UPDATE_REQUEST;
    }
  }, [dispatch, match, startPresenterAddedToChimeSLI]);
  (0, _react.useEffect)(function () {
    endPresenterAddedToChimeSLI(sources, getKnockApprovalFailureMessage(notification));
  }, [sources, notification, endPresenterAddedToChimeSLI]);
  var onToggleNotification = (0, _react.useCallback)(function (status) {
    dispatch(toggleNotificationListAction(status));
  }, [dispatch]);
  var handleMouseEnter = (0, _react.useCallback)(function () {
    var remaining = timeRemaining - Date.now() - start;
    clearTimeout(notificationTimer.current);
    setTimeRemaining(remaining);
  }, [start, timeRemaining]);
  var handleMouseLeave = (0, _react.useCallback)(function () {
    dispatch(toggleNotificationListAction(false));
  }, [dispatch]);
  return {
    /** exposing timeRemaining only for testing purposes. Not to be used in component */
    timeRemaining: timeRemaining,
    onApproveAll: onApproveAll,
    updateKnockRequest: updateKnockRequest,
    onToggleNotification: onToggleNotification,
    handleMouseEnter: handleMouseEnter,
    handleMouseLeave: handleMouseLeave
  };
}
var _default = exports["default"] = useKnockRequest;